// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBell_badge__8fiZ-"};